import type { TenantUsage } from '@/api/types'
import { cn } from '@/lib/format'
import { CheckIcon } from './icons'

const STEPS: Array<{ key: keyof TenantUsage['onboarding']; label: string }> = [
  { key: 'has_teams', label: 'Teams' },
  { key: 'has_players', label: 'Players' },
  { key: 'has_season', label: 'Season' },
  { key: 'has_games', label: 'Games' },
  { key: 'has_final_game', label: 'Final game' },
]

/**
 * How far a league has got through setup. Done steps are ticked, the first
 * missing step is where they're stuck. A list, so it wraps on phones.
 */
export function OnboardingSteps({ state }: { state: TenantUsage['onboarding'] }) {
  const stuck = STEPS.findIndex((s) => !state[s.key])
  const done = STEPS.filter((s) => state[s.key]).length
  return (
    <div className="grid gap-2">
      <ol className="grid grid-cols-5 gap-1.5" aria-label={`Setup progress: ${done} of ${STEPS.length} steps done`}>
        {STEPS.map((s, i) => {
          const ok = state[s.key]
          const isStuck = i === stuck
          return (
            <li key={s.key} className="grid min-w-0 gap-1.5">
              <span aria-hidden className={cn('h-1.5 rounded-full', ok ? 'bg-good' : isStuck ? 'bg-warn' : 'bg-toggle-off')} />
              <span className={cn('flex min-w-0 items-center gap-1 text-2xs font-semibold', ok ? 'text-ink' : isStuck ? 'text-warn' : 'text-subtle')}>
                {ok ? <CheckIcon size={11} className="shrink-0 text-good" /> : null}
                <span className="truncate">{s.label}</span>
                <span className="sr-only">{ok ? ' (done)' : isStuck ? ' (next step)' : ' (not yet)'}</span>
              </span>
            </li>
          )
        })}
      </ol>
      <p className="text-xs text-muted">{stuck === -1 ? 'Fully set up.' : `Next step: ${STEPS[stuck].label.toLowerCase()}.`}</p>
    </div>
  )
}
